import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { OptionsItemFormGroup } from '../question-item-editor.model';

@Component({
  selector: 'dojo-question-item-options-template-container',
  template: `
    <ng-container
      *ngTemplateOutlet="
        optionsViewerTemplate();
        context: {
          $implicit: optionsFormGroup(),
          optionsIndex: optionsIndex()
        }
      "
    ></ng-container>
  `,
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionItemOptionsTemplateContainerComponent {
  readonly optionsFormGroup = input.required<OptionsItemFormGroup>();
  readonly optionsIndex = input.required<number>();

  readonly optionsViewerTemplate =
    input.required<TemplateRef<{ $implicit: OptionsItemFormGroup; optionsIndex: number }>>();
}
